import { useDisclosure } from "@chakra-ui/react";
import { TeamUser } from "lib/types";
import { createContext, FC, useContext, useRef, useState } from "react";
import { RemoveTeamUserAlertDialog } from "./removeTeamUserAlertDialog";

const TeamUserActionContext = createContext(null);

export const TeamUserActionProvider: FC = ({ children }) => {
  const [teamUser, setTeamUser] = useState<TeamUser>(null);
  const ref = useRef(null);
  const deleteTeamUserAlert = useDisclosure();

  const openDelete = (teamUser: TeamUser, onClose: () => void) => {
    ref.current = onClose;
    setTeamUser(teamUser);
    deleteTeamUserAlert.onOpen();
  }

  const handleCloseDelete = () => {
    deleteTeamUserAlert.onClose();

    if (ref.current) {
      ref.current();
      ref.current = null;
    }
    
    setTeamUser(null);
  }

  return (
    <TeamUserActionContext.Provider value={{teamUser, setTeamUser, openDelete}}>
      {children}
      <RemoveTeamUserAlertDialog isOpen={deleteTeamUserAlert.isOpen} onClose={handleCloseDelete} />
    </TeamUserActionContext.Provider>
  )
}

export const useTeamUserActionContext = () => useContext(TeamUserActionContext);
